import { combineReducers } from "redux";
import movieReducer from "./movie/movieReducer";
import searchReducer from "./search/searchReducer";
import genreReducer from "./genre/genreReducer";
import genreOfmovieReducer from "./movieOfgenre/movieOfgenreReducer";

const rootReducer = combineReducers({
  movieState: movieReducer,
  searchState: searchReducer,
  genreState: genreReducer,
  movieOfgenreState: genreOfmovieReducer,
});

export default rootReducer;
